import { Store } from 'src/store';

const getImagesCount = (store: Store) => store.gallery.images.length;

export default getImagesCount;
